import {
  ESelect,
  ETextInput,
  ENumberInput,
} from "../../../../../libs/ui";
import { Grid } from "@mantine/core";
import useELISATests from "./hook/useELISATests";

const DATA_OPTIONS = [
  { label: "Negative", value: "Negative" },
  { label: "Positive", value: "Positive" },
  { label: "Borderline", value: "Borderline" },
];

export default function ELISATests() {
  const { elisaData, handleChange } = useELISATests();

  return (
    <>
      {/* H. pylori ELISA */}
      <Grid className="mb-4">
        <Grid.Col span={4}>
          <ESelect
            label="H. pylori ELISA Status"
            placeholder="Select Status"
            size="md"
            data={[
              { label: "Done", value: "Done" },
              { label: "Not done", value: "Not done" },
            ]}
            value={elisaData.h_pylori_elisa}
            onChange={(e) => handleChange("h_pylori_elisa", e ?? "")}
          />
        </Grid.Col>
        {elisaData.h_pylori_elisa === "Not done" && (
          <Grid.Col span={8}>
            <ETextInput
              label="If not done, Why?"
              placeholder="Specify reason"
              size="md"
              value={elisaData.h_pylori_elisa_why_not_done}
              onChange={(e) => handleChange("h_pylori_elisa_why_not_done", e.target.value)}
            />
          </Grid.Col>
        )}

        {elisaData.h_pylori_elisa === "Done" && (
          <>
            <Grid.Col span={4}>
              <ENumberInput
                label="ELISA Value"
                placeholder="Enter numerical value"
                size="md"
                decimalScale={4}
                value={elisaData.h_pylori_elisa_value}
                onChange={(e) => handleChange("h_pylori_elisa_value", e !== undefined && e !== null ? String(e) : "")}
              />
            </Grid.Col>
            <Grid.Col span={4}>
              <ESelect
                label="H.p ELISA Result"
                placeholder="Select Result"
                size="md"
                data={DATA_OPTIONS}
                value={elisaData.h_pylori_elisa_result}
                onChange={(e) => handleChange("h_pylori_elisa_result", e ?? "")}
              />
            </Grid.Col>
          </>
        )}
      </Grid>
      {/* S. typhi ELISA */}
      <Grid className="mb-4">
        <Grid.Col span={4}>
          <ESelect
            label="S. typhi ELISA Status"
            placeholder="Select Status"
            size="md"
            data={[
              { label: "Done", value: "Done" },
              { label: "Not done", value: "Not done" },
            ]}
            value={elisaData.s_typhi_elisa}
            onChange={(e) => handleChange("s_typhi_elisa", e ?? "")}
          />
        </Grid.Col>

        {elisaData.s_typhi_elisa === "Not done" && (
          <Grid.Col span={8}>
            <ETextInput
              label="If not done, Why?"
              placeholder="Specify reason"
              size="md"
              value={elisaData.s_typhi_elisa_why_not_done}
              onChange={(e) => handleChange("s_typhi_elisa_why_not_done", e.target.value)}
            />
          </Grid.Col>
        )}
        {elisaData.s_typhi_elisa === "Done" && (
          <>
            <Grid.Col span={4}>
              <ENumberInput
                label="ELISA Value"
                placeholder="Enter numerical value"
                size="md"
                decimalScale={4}
                value={elisaData.s_typhi_elisa_value}
                onChange={(e) => handleChange("s_typhi_elisa_value", e !== undefined && e !== null ? String(e) : "")}
              />
            </Grid.Col>
            <Grid.Col span={4}>
              <ESelect
                label="S. typhi ELISA Result"
                placeholder="Select Result"
                size="md"
                data={DATA_OPTIONS}
                value={elisaData.s_typhi_elisa_result}
                onChange={(e) => handleChange("s_typhi_elisa_result", e ?? "")}
              />
            </Grid.Col>
          </>
        )}
      </Grid>
    </>
  );
}
